module.exports = new __parcel__URL__("safe_grayscale.6a8a0e92.png").toString();